Hop.defineModule('svg-icon-list', (root, param = {}) => {
    const iconName = param.name || null;
    const color = param.color || null;

    if (!iconName) {
        throw new Error('Missing name parameter for your icon module');
    }

    function createIconElement() {
        const i = document.createElement('joy-icon');
        i.setAttribute('name', iconName);

        if (color) {
            i.setAttribute('color', color);
        }

        return i;
    }

    function insertSvg(node) {
        node.prepend(createIconElement());
    }

    function scanListItems(ul) {
        ul.querySelectorAll('li').forEach((li) => insertSvg(li));
    }

    function scanLists() {
        root.querySelectorAll('ul').forEach((ul) => scanListItems(ul));
    }

    function init() {
        scanLists();
    }

    init();

    return function destroy() {
        // Nothing to do here yet.
    };
});
